import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getItem } from '../../../utility/Storage.utility';

dayjs.extend(utc);

const savedFrom = getItem('from');
const savedTo = getItem('to');

const defaultFrom = `${dayjs.utc().year()}-01-01T00:00:00Z`;
const defaultTo = `${dayjs.utc().year()}-12-31T23:59:59Z`;

const isValidSavedFrom =
  typeof savedFrom === 'string' && dayjs.utc(savedFrom).isValid();
const isValidSavedTo = typeof savedTo === 'string' && dayjs.utc(savedTo).isValid();
const hasValidSavedRange =
  isValidSavedFrom &&
  isValidSavedTo &&
  dayjs.utc(savedFrom).valueOf() <= dayjs.utc(savedTo).valueOf();

export const FilterConf = {
  schema: null,
  initialState: {
    value: {
      from: hasValidSavedRange ? savedFrom : defaultFrom,
      to: hasValidSavedRange ? savedTo : defaultTo,
    },
  },
  fields: [],
  query: {
    keys: [
      {
        key: 'createdAt',
        value: 'from',
        operator: '$gte',
      },
      {
        key: 'createdAt',
        value: 'to',
        operator: '$lte',
      },
    ],
  },
};
